export const HTML_ENTITIES_UNICODE = [
	{ entity: '\u00A0', character: ' ' }, // &nbsp;
	{ entity: '\u0020', character: ' ' }, // Space character
	{ entity: '\u003C', character: '<' }, // &lt;
	{ entity: '\u003E', character: '>' }, // &gt;
	{ entity: '\u0026', character: '&' }, // &amp;
	{ entity: '\u0022', character: '"' }, // &quot;
	{ entity: '\u0027', character: "'" }, // &apos;
	{ entity: '\u2013', character: '–' }, // &ndash;
	{ entity: '\u2014', character: '—' }, // &mdash;
	{ entity: '\u00A9', character: '©' }, // &copy;
	{ entity: '\u00AE', character: '®' }, // &reg;
	{ entity: '\u2122', character: '™' }, // &trade;
	{ entity: '\u20AC', character: '€' }, // &euro;
	{ entity: '\u00A3', character: '£' }, // &pound;
	{ entity: '\u00A5', character: '¥' }, // &yen;
	{ entity: '\u00A2', character: '¢' }, // &cent;
	{ entity: '\u2026', character: '…' } // &hellip;
]
